import { CreatorPage } from "@/components/creators";
import { queryClient } from "@/components/providers";
import {
  creatorsControllerDetailCreator,
  getCreatorsControllerDetailCreatorQueryKey,
} from "@/lib/lutely-api/gen/creators/creators";
import type { DetailCreatorDto } from "@/lib/lutely-api/gen/dtos";
import { CREATOR_ROUTE_DETAIL } from "@/utils/routeUtils";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/creators/$CREATOR_ID")({
  ...CREATOR_ROUTE_DETAIL,
  loader: async ({ params }) => {
    try {
      const creator = await queryClient.fetchQuery({
        queryKey: getCreatorsControllerDetailCreatorQueryKey(params.CREATOR_ID),
        queryFn: () => creatorsControllerDetailCreator(params.CREATOR_ID),
      });
      return { creator };
    } catch {
      return { creator: null as DetailCreatorDto | null };
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { CREATOR_ID } = Route.useParams();
  // Keyed by creator so switching artists fully remounts the page — inline
  // edit sections hold local state that must not survive an artist change
  return <CreatorPage key={CREATOR_ID} creatorIdOrSlug={CREATOR_ID} />;
}
